import { createAction, props } from '@ngrx/store';
import { ProfileModel } from '../models/profile.model';

export enum ProfileActionTypes {
  loadProfileBegin = '[PROFILE] Load Profile Begin',
  loadProfileSuccess = '[PROFILE] Load Profile Success',
  loadProfileFail = '[PROFILE] Load Profile Fail',

  updateProfileBegin = '[PROFILE] Update Profile Begin',
  updateProfileSuccess = '[PROFILE] Update Profile Success',
  updateProfileFail = '[PROFILE] Update Profile Fail',
}

// GET
export const loadProfileBeginAction = createAction(
  ProfileActionTypes.loadProfileBegin
);

export const loadProfileSuccessAction = createAction(
  ProfileActionTypes.loadProfileSuccess,
  props<{ payload: ProfileModel }>()
);

export const loadProfileFailAction = createAction(
  ProfileActionTypes.loadProfileFail,
  props<{ errors: any }>()
);

// UPDATE
export const updateProfileBeginAction = createAction(
  ProfileActionTypes.updateProfileBegin,
  props<{ profileForm: { name: string; email: string } }>()
);

export const updateProfileSuccessAction = createAction(
  ProfileActionTypes.updateProfileSuccess,
  props<{ response: ProfileModel }>()
);

export const updateProfileFailAction = createAction(
  ProfileActionTypes.updateProfileFail,
  props<{ errors: any }>()
);
